import AdLoadProgressTable from "./loadStep/AdLoadProgressTable";

const LoadStep = () => {
  return <AdLoadProgressTable />;
};

export default LoadStep;
